import { Pipe, PipeTransform } from '@angular/core';
import { Project360Service } from '../../modules/p-dashboard/project360.service';
import { Project } from '../../modules/projects/projects-api-models';
import { AccessLevel } from '../../core/user/user.model';

@Pipe({
  name: 'hasPermission',
  pure: true,
})
export class PermissionCheckPipe implements PipeTransform {
  constructor(private _project: Project360Service) {}

  transform(project: Project, accessLevel: AccessLevel): boolean {
    if (!project) {
      return false;
    }
    return this._project.getProjectPermission(accessLevel, project);
  }
}
